import './App.css';
import { BrowserRouter, Routes, Route} from "react-router-dom";
import MainContainer  from './component/MainContainer.js';

function App() {
  return (
      <BrowserRouter>
       <Routes>
        <Route path="/" element={<MainContainer />} />
        <Route path="/:code" element={<MainContainer/>} />
        <Route path="/:pj/:code" element={<MainContainer/>} />
       </Routes>
      </BrowserRouter>
  );
}

export default App;
